import { useLocation } from "react-router-dom";

/**
 * @deprecated use useQuerystring from `utils/useQuerystring` instead.
 */
export function useQuerystring() {
  const { search } = useLocation();
  return Object.fromEntries(new URLSearchParams(search).entries());
}
